// Verification gate helpers (web). Posting a job request or a gig needs only Basic; hiring, being hired,
// creating an order or escrow, adding funds and withdrawing need Secondary. The server is the gate; these
// helpers only decide when the client shows the verification prompt instead of a raw error.

// Same rule as the order gate on GigDetail: Secondary (ID or a verified payment method) or Full.
export const isSecondaryVerified = (user) => ['secondary', 'full'].includes(user?.verificationLevel);

// The server's "you need Secondary" refusal: 403 with requiredLevel 'secondary'. A counterparty refusal
// (GIGGER_NOT_VERIFIED / SHIPPER_NOT_VERIFIED) carries no requiredLevel and is shown as the server's message.
export const isSecondaryVerificationError = (err) =>
  err?.response?.status === 403 && err.response.data?.requiredLevel === 'secondary';

// The server's "you need Basic" refusal when posting a job request or a gig: 403 with requiredLevel 'basic'
// (requireBasicVerification). The user has not verified email and phone yet.
export const isBasicVerificationError = (err) =>
  err?.response?.status === 403 && err.response.data?.requiredLevel === 'basic';
